import { useContext } from "react";
import { GemmaContext, type GemmaContextValue } from "./gemmaContext";

export const useGemma = (): GemmaContextValue => {
  const ctx = useContext(GemmaContext);
  if (!ctx) {
    throw new Error("useGemma must be used inside <GemmaProvider>");
  }
  return ctx;
};
